import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { getNovelties } from '../../../../../redux/actions/novelties'
import { getTags } from '../../../../../redux/actions/tags'
import { IRootState } from '../../../../../redux/types'

export const useNewsFilters = () => {
  const { t } = useTranslation(['global'])
  const dispatch = useDispatch()
  const { news, reload, showForm, loading } = useSelector((state: IRootState) => state.novelty)
  const { tags } = useSelector((state: IRootState) => state.tag)
  const { globalFamilyId, globalBrandId, globalCountriesId, globalLanguageId } = useSelector((state: IRootState) => state.global)

  const status = [
    { id: 0, name: 'Activo' },
    { id: 1, name: 'Inactivo' },
    { id: 2, name: 'Borrador' }
  ]
  const visibility = [
    { id: 0, name: t('close') },
    { id: 1, name: 'VIP' }
  ]
  const optionsData = [
    { data: status, code: 'status', column: 'status' },
    { data: visibility, code: 'visibility', column: 'visibility' },
    { data: tags, code: 'categories', column: 'tag_id' }
  ]

  useEffect(() => {
    if (tags.length === 0) dispatch(getTags())
  }, [dispatch, tags.length])

  useEffect(() => {
    if (globalLanguageId !== null && globalCountriesId.length > 0) {
      fetchNews()
    }
  }, [globalFamilyId, globalBrandId, globalLanguageId, globalCountriesId])

  useEffect(() => {
    if (reload) {
      fetchNews()
    }
  }, [reload])

  const fetchNews = () => {
    dispatch(
      getNovelties({
        family_id: globalFamilyId,
        brand_id: globalBrandId,
        language_id: globalLanguageId,
        countries: globalCountriesId,
        requesttype: 2,
        type: 'news'
      })
    )
  }

  return {
    news,
    showForm,
    loading,
    tags,
    globalBrandId,
    optionsData,
    fetchNews
  }
}
